import { useMyIssues } from '../../hooks/useSystemIssues'
import { TriageQueueList } from '../triage/TriageQueueList'

interface MyIssuesListProps {
  onSelect: (issueId: number) => void
}

/** "Meus problemas" (painel "Relatar um problema"): a mesma tabela da fila do
 * HUB, sem "Reportado por" (é sempre a pessoa) e sem controles de dev. */
export function MyIssuesList({ onSelect }: MyIssuesListProps) {
  const { data: issues = [], isLoading } = useMyIssues()
  return (
    <TriageQueueList
      issues={issues}
      isLoading={isLoading}
      onSelect={onSelect}
      showReporterMeta={false}
      canEditPriority={false}
      countLabel={['problema', 'problemas']}
      emptyText="Você ainda não reportou nenhum problema."
    />
  )
}
